<template>
  <div
    class="scmcc-login-page"
    :style="{
      backgroundImage: `url(${envConst.SCMCC_HOST}/images/sign_bgtexture.png)`
    }"
  >
    <div class="login-page-wrapper">
      <div class="banner">
        <div class="banner-wrapper">
          <h2 class="title">为您留住每一位客户</h2>
          <h3 class="sub-title">您创造伟大的成就，我们提供美满的服务</h3>
          <img
            class="sign-image"
            :src="`${envConst.SCMCC_HOST}/images/sign_pic.png`"
          />
        </div>
      </div>
      <div class="content">
        <div class="scmcc-register-form-wrapper">
          <div :class="['errorInfo', { noShow: !errorInfo }]">
            {{ errorInfo }}
          </div>
          <div class="scmcc-register-logo">
            <p class="register-title">欢迎注册xxxxx</p>
          </div>
          <Form
            class="scmcc-register-form"
            ref="formRegister"
            :model="registerForm"
          >
            <FormItem class="scmcc-register-form-item">
              <i-input
                v-model="registerForm.phone"
                placeholder="请输入手机号"
                @on-keyup="filterTel"
                @on-blur="uniqueTel"
                @on-enter="handleSubmit"
              ></i-input>
            </FormItem>
            <FormItem class="scmcc-register-form-item">
              <i-input
                placeholder="请输入验证码"
                v-model="registerForm.code"
                @on-keyup="filterCode"
                @on-blur="filterCode"
                @on-enter="handleSubmit"
              >
                <template v-slot:append>
                  <div
                    style="width:100%;height:52px;"
                    :class="!clickCheck ? 'gray' : ''"
                    @click="getCodeCheckPhone"
                  >
                    <span v-if="show">{{ timemsg }}</span>
                    <span v-if="!show">重新获取({{ count }})</span>
                  </div>
                </template>
              </i-input>
            </FormItem>

            <FormItem class="scmcc-register-form-item lastly">
              <Button
                type="primary"
                long
                :loading="loading"
                @click="handleSubmit"
                >下一步</Button
              >
            </FormItem>
          </Form>
          <p class="bottom-tip-text accept-text">
            注册即代表您同意并接受
            <span @click="showPopView(true,false)">《xxxxx系统服务条款》</span>
          </p>
          <p class="bottom-tip-text accept-text">
            和
            <span @click="showPopView(false,true)">《xxxxx外链管理规范》</span>
          </p>
          <p class="bottom-tip-text jump-text">
            已有账户，直接
            <span @click="toLogin">登录</span>
          </p>
        </div>
      </div>
      <!-- 用户协议弹窗 -->
      <div v-if="showAccept" class="accept-pop-wrapper">
        <div class="accept-pop-content">
          <div class="close-img">
            <img
              @click="hidePopView"
              :src="`${envConst.SCMCC_HOST}/images/close.svg`"
            />
          </div>
          <p v-if="ariticle1" class="accept-title">xxxxx系统服务条款</p>
          <p v-if="ariticle2" class="accept-title">xxxxx外链管理规范</p>
          <div v-if="ariticle1" class="list-content">
            <p>
              欢迎您使用xxxx服务有限公司（以下简称“xxxx”）提供的xxxxx系统，在您申请注册成为xxxxx系统的客户之前，请仔细阅读下列内容。如果您在注册过程中选择“同意遵守【xxxxx系统服务条款】”选项即表示完全接受本条款的所有内容，如果您不接受本条款，请不要安装、使用、注册或以其他方式访问我们的服务。以下服务条款请您（xxxxx系统服务使用者，以下简称“您”）详细阅读了解：
              “我们”、“我公司”：即系统所有人xxxx服务有限公司为xxxxx系统的开发商，依法独立拥有xxxxx系统的产品著作权。
              “本软件”：xxxxx系统。
              “您”：xxxxx系统服务使用者，以下简称“您”。
              “本协议”、“本条款”：即【xxxxx系统服务条款】，本协议适用且仅适用于xxxxx系统，xxxx服务有限公司拥有在法律允许范围内对本协议的解释权。
            </p>
            <p>一、服务条款的确认和接纳</p>
            <p>
              1、xxxxx系统的所有权和运营权归xxxx服务有限公司所有。为获得xxxxx系统所提供的相关服务，您需要同意本条款内容并按照页面上的提示完成注册程序。并在明确理解的前提下注册，包括接受xxxx对服务条款随时所做的任何修改，并且在知情的基础上明确同意按条款的规定处理和使用。
            </p>
            <p>
              2、xxxx有权在必要时修改本条款，本条款一旦发生变动，将会在相关页面上公布修改后的服务条款。修改后的服务一旦在网页上公布即有效代替原来的服务条款。您可随时登陆xxxx云客服门户网站查阅最新版服务条款。
            </p>
            <p>二、使用规则</p>
            <p>
              1、您需要先同意我们的服务条款，成为我们网站的注册账户，才能使用我们的服务。在您注册时，我们会要求您提供个人信息，例如您的姓名、电子邮件地址和密码、电话号码等。这些信息视为您的身份识别信息，注册即为您同意我们用这些信息来管理您的账户，并为您提供一系列服务的访问，我们也可以利用这些信息来通知您最新的产品更新和市场活动。您对前述个人信息内容拥有所有权并独立承担全部法律义务，如因该等信息损害软件所有人或他人权益，您应承担全部赔偿责任。
            </p>
            <p>
              2、您注册成功后，我们将给予您相应的帐号及密码，该帐号和密码由您负责保管，请您不要将您的帐号、密码转让或出借予他人使用。如您发现您的帐号遭他人非法使用，应立即通知我们并授权我们作出处理。
            </p>
            <p>
              3、确保您在每个上网时段结束时，以正确步骤离开网站。我们不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。除非有法律规定或司法裁定，且征得我公司的同意，否则，您的用户名和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。因他人未经授权使用您的用户名和密码造成的损失由您自行承担或依法由擅用人承担，本网站尽力保证您的账户安全但不保证您账户安全的绝对性。
            </p>
            <p>
              4、您在使用我们的系统服务时，需要做好网络安全与信息安全工作，遵守国家与网络安全和信息安全相关的法律法规，遵守我们的网络安全和信息安全相关的管理制度和规范。
            </p>
            <p>
              5、您需要在接入xxxx语音专线管控平台的前提下开展业务，以防范电信诈骗及其他电信服务违规使用行为。
            </p>
            <p>
              6、您应保障将xxxxx系统服务应用于合法领域，并承担由此产生的一切责任，因用户违法所造成xxxx服务有限公司的损失、赔偿或第三方权利主张，则用户将承担全部法律责任及赔偿，使得xxxx服务有限公司免于遭受相关责任及赔偿。
            </p>
            <p>
              7、在使用过程中，必须保证不对xxxxx系统的相关软件进行任何反向编译或破解，如有违反，应承担违约责任并赔偿由此给我们造成的全部损失。
            </p>
            <p>
              8、未经我们授权情况下，您不得在相关的产品的推广宣传中免费使用xxxx的商标、字号和Logo，不得把我们作为典型合作案例进行推广，否则应承担违约责任并赔偿由此造成的全部损失。
            </p>
            <p>9、您在使用我们提供的服务时，必须遵循以下原则：</p>
            <p>
              •
              不得危害国家安全、泄露国家秘密，不得侵犯国家社会集体的和公民的合法权益，不得制作、复制、查阅和传播下列信息：
            </p>
            <p>• 违反宪法确定的基本原则的；</p>
            <p>• 危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；</p>
            <p>• 损害国家荣誉和利益的；</p>
            <p>• 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p>• 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
            <p>• 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
            <p>• 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
            <p>• 侮辱或者诽谤他人，侵害他人合法权益的；</p>
            <p>• 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
            <p>• 以非法民间组织名义活动的；</p>
            <p>• 含有法律、行政法规禁止的其它内容的。</p>
            <p>
              • 不得用任何不正当手段损害我们及其他用户的利益及声誉。
              违反上述规定的，我们有权终止对您进行服务，并协助互联网有关行政机关等进行追索和查处。
            </p>
            <p>三、收费服务</p>
            <p>
              1、xxxxx系统所提供的技术服务是以收费方式提供的。一旦您申请购买服务，您应按有关的收费标准、付款方式支付相关服务费。资费说明详见xxxx云客服门户网站。
            </p>
            <p>
              2、我公司有权按需要修改或变更所提供的收费服务、收费标准、收费方式、服务费及服务条款。如果出现任何产品价格变动，以最后发布的通知为准。
            </p>
            <p>
              3、逾期付费：服务费逾期交纳应按xxxx或合作公司关于迟延付费的相应的规定办理。
            </p>
            <p>四、保密条款</p>
            <p>
              1、在使用我们的系统服务过程中，如触及和知晓的有关我们的设备、网络情况、业务程序及方式、管理的方法制度和专有技术等，无论此种信息的形式和目的为何，均为我们的保密信息。
            </p>
            <p>
              2、 未经我们书面同意，您不得复制、记录或以其他方式泄露上述信息。
            </p>
            <p>
              3、
              拥有信息的一方根据本条款向另一方提供的信息，包括但不限于技术性信息、商业性信息、文件、程序、计划、技术、图表、模型、参数、数据、标准、专有技术、业务或业务运作方法以及其他专有信息。服务过程中形成的所有信息、数据、资料、阶段性成果和最终成果，本服务条款和与本条款有关的其他商业信息和技术信息(以下统称“保密信息”)，只能由接受方及其人员为本条款目的而使用。除本条款另有规定外，对于提供方提供的任何保密信息，未经提供方的书面同意，接受方及其知悉保密信息的人员均不得直接或间接地以任何方式提供、披露或转让给任何第三方，或许可第三方使用，或以保密信息为任何第三方提供任何意见或建议。
            </p>
            <p>
              4、
              本条款任何一方同意对获悉的对方之上述保密资料予以保密，并严格限制接触上述保密信息的员工遵守本条之保密义务。除非国家机关依法强制要求或上述保密资料已经进入公有领域外，接受保密资料的一方不得对外披露。
            </p>
            <p>
              5、
              如您的律师、会计师、承包商和顾问为提供专业协助而需要了解保密信息时，您可向其披露保密信息，但是，应要求上述人员签订保密协议或按照有关职业道德标准履行保密义务。
            </p>
            <p>
              6、
              如相关政府部门或监管机构要求您披露任何保密信息，接受方可在该政府部门或机构要求的范围内做出披露而无需承担本服务条款项下的责任。但前提是，您应立即将需披露的信息书面通知我们，以便提供方采取必要的保护措施，且该等通知应尽可能在信息披露前做出，并且您应尽商业上合理的努力确保该等被披露的信息获得有关政府机关或机构的保密待遇。
            </p>
            <p>7、 本条款所规定的保密义务期限为永久持续有效。</p>
            <p>五、知识产权</p>
            <p>
              1、xxxxx系统由xxxx服务有限公司研发，xxxxx产品相关软件及技术的知识产权归xxxx服务有限公司所有，您应保证不对我们的相关软件进行任何反向编译或破解；您须在经我们书面许可的情况下，才可以对第三方公司提供。
            </p>
            <p>
              2、除xxxx或第三方事先明示同意外，您无权复制、传播、转让、许可或提供他人使用xxxxx系统资源，否则必须承担相应的责任。
            </p>
            <p>六、免责声明</p>
            <p>如发生下述情形，本网站及xxxx不承担任何法律责任：</p>
            <p>1、依据法律规定或相关政府部门的要求提供您的个人信息；</p>
            <p>2、由于您的使用不当而导致任何个人信息的泄露；</p>
            <p>
              3、任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的情形；
            </p>
            <p>
              4、用户因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形
            </p>
            <p>
              5、xxxx服务有限公司对您或第三方提供的应用于或操作于“xxxxx”的内容或与该内容相关的其他内容而引起的任何索赔或损害不承担任何责任。
            </p>
            <p>七、 其他条款</p>
            <p>
              1、本服务条款的成立、有效性、解释、履行、签署、修订和终止以及争议的解决均应适用中华人民共和国大陆地区法律。
            </p>
            <p>
              2、如果任何争议或权利要求起因于本条款或与本条款有关或与本条款的解释、违约、终止或效力有关，都应由双方通过友好协商解决。双方通过协商不能解决争议，向我公司所在地有管辖权的人民法院提起诉讼。
            </p>
            <p>
              3、争议解决过程中，除双方有争议的部分外，本合同其他部分仍然有效，双方应继续履行。
            </p>
          </div>
          <div v-if="ariticle2" class="list-content">
            <p>一. 原则</p>
            <p>
              xxxxx致力于为企业提供简单强大的客服中心系统，通过【自定义功能】满足企业的个性化需求，其中包含表单外链功能。
            </p>
            <p>
              为了建立良好的用户体验，我们严厉打击滥用外链表单的行为，并出台 《xxxxx外链管理规范》。
            </p>
            <p>
              对于违反本规范的内容，一经发现将立即进行处理，包括但不限于封禁表单以及封禁注册账号 。xxxxx有权依照本规范及相关协议、专项规则的规定，拒绝再向前述主体提供服务。
            </p>
            <p>二. 外链表单违规内容</p>
            <p>
              外链表单的内容需遵守相关法律法规的规定。用户发布内容如涉及违反相关规定，一经发现将根据违规程度采取相应的处理措施，包括但不限于：
            </p>
            <p>
              1. 诱导分享/关注
            </p>
            <p>
              1）诱导分享：强制或诱导用户将消息分享至朋友圈的行为。奖励的方式包括但不限于：实物奖品、虚拟奖品（积分、信息）等。
            </p>
            <p>
              2）诱导关注：以奖励或其他方式，强制或诱导用户关注公众号的行为。奖励的方式包括但不限于：实物奖品、虚拟奖品（积分、信息）等。包括以下类型：
            </p>
            <p>
              •	强制用户分享：分享后才能继续下一步操作。包括但不限于：分享后方可预订，分享后方可知道答案等。
            </p> 
              •	利诱用户分享：分享后对用户有奖励。包括但不限于：邀请好友拆礼盒，集赞，分享可增加一次抽奖机会等。
            <p>
              •	胁迫、煽动用户分享：用夸张言语来胁迫、引诱用户分享。包括但不限于 ：“不转不是中国人”“请好心人转发一下”“转发后一生平安”“转疯了”“必转”等。
            </p>
            <p>
              2. 违法经营
            </p>
            <p>
              1）非法分销；
            </p>
            <p>
              2）未取得法定许可证件或牌照、未获得在先的行政许可或未符合监管部门的要求，发布、传播或从事相关经营活动的行为，包括但不限于违规发布药品或医疗器械推广内容的、违规发布证券或期货等投资类有偿咨询内容的、违规发布烟草宣传内容的；
            </p>
            <p>
              3）以任何形式参与、鼓励、促进或诱导他人排斥正常商业竞争的行为，或为前述行为的传播提供便利的。
            </p>
            <p>3. 多级分销经营</p>
            <p>
              实施多级分销欺诈行为，发布分销信息诱导用户进行关注、分享或直接参与。此模式多数包装为新型商业模式、创新金融产品、互助扶贫、国家帮扶计划等，本质在于利用关系链发展人员，形成多级上下线关系，按照下线人数或者销售业绩计算盈利，与传销行为类似，一定程度上具有金字塔欺诈、庞氏骗局等特征。
            </p>
            <p>
              违规示例：
            </p>
            <p>
              •	通过发展人员形成上下线关系，依据下线人数、销售业绩等为依据计算和给付上线报酬；
            </p>
            <p>
              •	以金融互助、贫困帮扶、代理权限等方式诱导用户滚动发展下级人员；
            </p>
            <p>
              •	下线人员交纳费用或以认购商品等方式变相交纳费用才能取得加入或者发展其他人员加入的资格。
            </p>
            <p>
              4. 欺诈、可疑服务及不诚信行为
            </p>
            <p>
              1）发布涉嫌以骗取钱财为目的的欺诈信息（例如网赚、中奖类信息）、涉嫌虚假夸大减肥、增高、丰胸、美白效果但明显无效的保健品、药品、食品信息或涉嫌推广、销售假冒伪劣商品的信息。
            </p>
            <p>
              2）采用虚构事实、隐瞒真相等手段，提供有偿或无偿服务，骗取他人钱财或诱使他人关注微信公众号、分享相关信息的行为。
            </p>
            <p>
              3）以自动化程序冒充真实用户、虚构用户信息等方式，有偿或无偿提供好友介绍、约会撮合、聚会召集等可疑服务。
            </p>
            <p>
              4）自行或协助他人以拟人程序、利诱其他用户参与、委托刷单平台等任何方式，实施非真实的点击、阅读、点赞、评价、刷单等操作，虚构、伪造、隐瞒包括但不限于阅读量、关注用户量、转发量、下载量、投诉量等各种数据信息的行为。
            </p>
            <p>
              5. 恶意违规及对抗行为
            </p>
            <p>
              1）规避平台运营审核的行为：使用特殊符号、图片等方式规避垃圾内容审核，使用反复多链接跳转替换发表相同垃圾内容等行为。
            </p>
            <p>
              2）其他行为：其他恶意违规及对抗行为，例如故意寻找漏洞与平台对抗的行为等。
            </p>
            <p>
              6. 庸俗挑逗性内容
            </p>
            <p>
              1）散布淫秽、色情内容，包括但不限于招嫖、寻找一夜情、性伴侣等内容；
            </p>
            <p>
              2）发送以色情为目的的情色文字、情色视频、情色漫画的内容，但不限于上述形式。
            </p>
            <p>
            3）直接或隐晦表现性行为、具有挑逗性或者侮辱性内容，或以带有性暗示、性挑逗的语言描述性行为、性过程、性方式的。
            </p>
            <p>
            4）以庸俗或挑逗性标题、内容、配图（包括封面缩略图）吸引用户阅读文章、关注微信公众帐号的，或标题、内容、配图（包括封面缩略图）含有使用户、阅读者产生不良、不正当影响等误导性内容的。
            </p>
            <p>
            5）传播非法性药品、性保健品、性用品和性病治疗营销信息等相关内容的。
            </p>
            <p>
            6）发布相关部门禁止传播的色情和有伤社会风化的文字、音视频内容的。
            </p>
            <p>
            7. 暴力内容
            </p>
            <p>
            1）散播人或动物被杀、致残以及枪击、刺伤、拷打等受伤情形的真实画面；
            </p>
            <p>
            2）出现描绘暴力或虐待儿童等内容；
            </p>
            <p>
            3）出现吸食毒品、自虐自残等令人不安的暴力画面内容；
            </p>
            <p>
            4）无资质销售仿真枪、弓箭、管制刀具、气枪等含有杀伤力枪支武器；
            </p>
            <p>
            5）出现以鼓励非法或鲁莽使用方式等为目的而描述真实武器的内容。
            </p>
            <p>
            8. 赌博类内容
            </p>
            <p>
            组织聚众赌博、出售赌博器具、传授赌博（千术）技巧、方式、方法等内容。
            </p>
            <p>
            9. 涉黑类内容
            </p>
            <p>
            发布替人复仇、收账等具有黑社会性质的信息；雇佣、引诱他人从事恐怖、暴力等活动；拉帮结派，招募成员，对社会秩序构成潜在危害的内容。
            </p>
            <p>
            10. 非法物品类内容
            </p>
            <p>
            包括但不限于买卖发票；出售假烟、假币、赃物、走私物品；违法办证刻章、代办身份证、信用卡、办理手机复制卡等信息；交易人体器官等内容。
            </p>
            <p>
            11. 违法推广、营销信息、广告类内容
            </p>
            <p>
            含有任何不符合法律法规要求的推广、营销信息、广告的内容，包括但不限于含有贩卖毒品、窃听器、军火、人体器官、迷药、国家机密、信用卡套现、办证、非法刻章、性虐等内容。
            </p>
            <p>12. 谣言类内容</p>
            <p>发送不实信息，制造谣言，可能对他人、企业或其他机构造成损害的内容。</p>
            <p>13. 误导类内容</p>
            <p>包括但不限于以下情况：</p>
            <p>•	表单标题使用夸张、惊悚、极端的词语和数据夸大其词；</p>
            <p>•	表单标题使用侮辱、煽动、低俗词语，使人不适；</p>
            <p>•	表单标题与内容不符、断章取义、偷换概念、歪曲事实；</p>
            <p>•	表单标题过多使用无实际意义的标点符号吸引眼球；</p>
            <p>•	旧闻翻炒故意误导。</p>
            <p>14. 非法获取用户数据、信息</p>
            <p>1）未经用户明确同意，并向用户如实披露数据用途、使用范围等相关信息的情形下复制、存储、使用或传输用户数据；
            </p>
            <p>
            2）要求用户共享个人信息（手机号、出生日期等）才可使用其功能，或收集用户密码或者用户个人信息（包括但不限于，手机号，身份证号，生日，住址等），如：贷款类表单，黄牛抢票表单。
            </p>
            <p>15. 其他涉及违法违规或违反相关规则的内容</p>
            <p>包括但不限于：</p>
            <p>1）违反宪法确定的基本原则的；</p>
            <p>2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
            <p>3）损害国家荣誉和利益的；</p>
            <p>4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p>5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
            <p>6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
            <p>7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
            <p>8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
            <p>9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
            <p>10）以非法民间组织名义活动的；</p>
            <p>11）含有法律、行政法规禁止的其他内容的。</p>
            <p>三. 举报机制</p>
            <p>
            xxxxx已启用用户举报处理机制，用户可以拨打400电话反馈。我们会根据用户的举报进行调查处理。
            </p>
            <p>四. 处罚机制</p>
            <p>1）永久封禁违规外链表单；</p>
            <p>2）永久封禁xxxxx帐号；</p>
            <p>3）付费用户概不退款；</p>
            <p>4）如果掌握了足够证据，我们将协助国家公安机关严厉打击违法行为。</p>
            <p>五. 免责声明</p>
            <p>xxxxx用户明确了解并同意：</p>
            <p>
            xxxxx不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对xxxxx帐号的使用行为必须自行承担相应风险。
            </p>
            <p>
              xxxxx用户明确了解并同意，本规范是在保障遵守国家法律法规、维护公序良俗，以及保护他人合法权益的基础上，为打造绿色、健康、优质平台的更高目标而制定的。xxxxx秉承该理念进行运营、管理和惩处规范，在能力范围内尽最大的合理努力依照有效的法律法规做出判断，但是并不保证其判断完全与司法机构、行政机关的判断一致，为此产生的后果xxxxx用户已经理解并同意自行承担。
            </p>
            <p>
              若用户利用xxxxx所收集、使用及处理的个人信息主体为其他国家法律法规所保护的主体信息（如欧盟《一般数据保护法案》项下规定和保护之个人信息），则用户应自行按照相关其他国家之法律要求及标准进行操作，若因用户的违反给任何第三方造成损失或引起任何法律责任的，则用户应自行承担全部赔偿及法律责任，用户应使得xxxx服务有限公司在此种情形下免于任何赔偿、责任承担及费用等。
            </p>
            <p>六. 动态文档</p>
            <p>
              本规范为动态文档，我们有权根据相关法律法规更新或产品运营的需要对其内容进行修改并更新，您应能反复查看以便获得最新信息。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { stringify } from 'qs'
import envConst from '../env-const.js'
export default {
  name: 'register',
  data: () => ({
    envConst,
    errorInfo: '',
    loading: false,
    showAccept: false,
    registerForm: {
      phone: '',
      code: ''
    },
    phoneUnique: false,
    clickCheck: false,
    clickStat: true,
    timemsg: '获取验证码',
    count: '',
    show: true
  }),
  created() {},
  methods: {
    toLogin() {
      this.$router.push('./login')
    },
    showPopView(param1, param2) {
      this.ariticle1 = param1;
      this.ariticle2 = param2;
      this.showAccept = true
    },
    hidePopView() {
      this.showAccept = false
    },
    filterTel() {
      this.registerForm.phone = this.registerForm.phone.replace(/[^\d]/g, '')
    },
    filterCode() {
      this.registerForm.code = this.registerForm.code.replace(/[^\d]/g, '')
    },
    // 手机号唯一性校验
    uniqueTel() {
      return new Promise((resolve,reject)=>{
                let regPhone = new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
      this.filterTel()
      if (!this.registerForm.phone) {
        this.errorMesage('请输入手机号')
        this.clickCheck = false
        return
      }
      if (!regPhone.test(this.registerForm.phone)) {
        this.errorMesage('请输入11位有效手机号')
        this.clickCheck = false
        return
      }
      this.$http
        .get('/sctm/NKsctmtenantinfos/validateNKTenant', {
          params: { validateType: 2, tenantPhone: this.registerForm.phone }
        })
        .then(({ data }) => {
          console.log(data)
          console.log('--------')
          if (!this.clickStat) {
            this.clickCheck = false
          } else {
            this.clickCheck = true
          }
          if (data.returnCode == 0) {
            if (data.bean) {
              this.phoneUnique = true
            } else {
              this.errorMesage('该手机号已存在')
              this.clickCheck = false
              this.phoneUnique = false
            }
          } else {
            this.phoneUnique = false
            this.errorMesage(data.returnMessage)
          }
          resolve(this.phoneUnique)

        })
        .catch(function(er) {
          console.log(er)
        })
      })
    },
    getCodeCheckPhone(){
      this.uniqueTel().then(res=>{
        console.log(res)
        this.getCode();
      });
    },
    getCode() {
      let regPhone = new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
      if (!this.clickStat) {
        this.errorMesage('请稍后点击获取验证码')
        return
      }
      if (!this.registerForm.phone) {
        this.errorMesage('请输入手机号')
        this.clickCheck = false
        return
      }
      if (!regPhone.test(this.registerForm.phone)) {
        this.errorMesage('请输入11位有效手机号')
        this.clickCheck = false
        return
      }
      if (!this.phoneUnique) {
        this.errorMesage('该手机号已存在')
        this.clickCheck = false
        return
      }
      let params = {
        userPhone: '' + this.registerForm.phone,
        smsType: '1'
      }
      this.$http
        .post(`${envConst.API_BASE_URL}/scsms/send/sendSmsCode`, params, {
          transformRequest: [data => stringify(data)]
        })
        .then(res => {
          this.clickCheck = false
          this.clickStat = false
          if (res.data.bean.rtnCode == '0000') {
            const TIME_COUNT = 60
            if (!this.timer) {
              this.count = TIME_COUNT
              this.show = false
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--
                } else {
                  this.show = true
                  clearInterval(this.timer)
                  this.timer = null
                  this.timemsg = '重新发送'
                  if (this.registerForm.phone) {
                    this.clickCheck = true
                  } else {
                    this.clickCheck = false
                  }
                  this.clickStat = true
                }
              }, 1000)
            }
          } else {
            this.clickStat = true
            this.errorMesage(res.data.bean.rtnMsg)
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    // 注册第一步信息提交，进行短信验证码校验
    handleSubmit() {
      let regPhone = new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
      let regCode = new RegExp(/^[0-9]{6}$/)
      if (!this.registerForm.phone) {
        this.errorMesage('请输入手机号')
        return
      }
      if (!regPhone.test(this.registerForm.phone)) {
        this.errorMesage('请输入11位有效手机号')
        return
      }
      if (!this.phoneUnique) {
        this.errorMesage('该手机号已存在')
        return
      }
      if (!this.registerForm.code) {
        this.errorMesage('请输入短信验证码')
        return
      }
      if (!regCode.test(this.registerForm.code)) {
        this.errorMesage('请输入6位合法验证码')
        return
      }

      this.disabled = true
      // 提交手机号和验证码，提交成功后跳转下一步
      let params = {
        smsType: '1',
        smsCode: this.registerForm.code,
        userPhone: this.registerForm.phone
      }
      this.$http
        .post(`${envConst.API_BASE_URL}/scsms/send/checkSmsCode`, params, {
          transformRequest: [data => stringify(data)]
        })
        .then(res => {
          if (res.data.bean.rtnCode == '0000') {
            this.$router.push({
              name: 'register2',
              params: {
                tel: this.registerForm.phone
              }
            })
          } else {
            this.disabled = false
            this.errorMesage(res.data.bean.rtnMsg)
          }
        })
        .catch(function(error) {
          this.disabled = false
          console.log(error)
        })
    },
    // 显示登录错误信息
    errorMesage(error) {
      this.errorInfo = error
      if (this.timer1) clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        this.errorInfo = ''
        this.timer1 = null
      }, 3000)
    }
  }
}
</script>

<style lang="stylus">
.scmcc-login-page
  height 100%
  width 100%
  overflow-y auto
  background #F3F6FC
  background-position center bottom
  background-repeat repeat-x

  .login-page-wrapper
    position relative
    width 100%
    max-width 1440px
    min-height 900px
    height 100%
    margin 0 auto

  .banner
    width 50%
    text-align center
    float left
    margin-top 128px
    user-select none

    .banner-wrapper
      display flex
      flex-flow column
      justify-content center
      height 683px

    .title
      font-size 46px
      color #1D1D26
      letter-spacing 2.3px

    .sub-title
      font-size 22px
      color #1D1D26
      letter-spacing 1.8px

    .sign-image
      width 100%
      max-width 785px

  .content
    position relative
    flex auto
    z-index 1

  .accept-pop-wrapper
    .accept-pop-content
      padding 20px 50px
      background #fff
      border-radius 5px
      position fixed
      width 1020px
      height 640px
      top 50%
      left 50%
      margin-left -510px
      margin-top -320px
      overflow hidden
      z-index 99

      .close-img
        text-align right

        img
          cursor pointer

      .accept-title
        margin-bottom 30px
        font-size 30px
        text-align center

      .list-content
        height 505px
        padding-left 10px
        padding-right 10px
        overflow-y auto
        overflow-x hidden

  .scmcc-register-form-wrapper
    width 480px
    padding 52px 53px 52px 50px
    border-radius 10px
    background #FFFFFF
    box-shadow 0 0 26px 0 rgba(47, 92, 184, 0.4)

    .errorInfo
      position absolute
      background #F8DDDC
      border-radius 4px
      text-align center
      line-height 52px
      width 480px
      height 52px
      font-size 16px
      color #E76461
      top 0
      left 0

      &.noShow
        display none

    .scmcc-register-logo
      display flex
      align-items center
      justify-content center
      margin 0 0 32px 0

      .register-title
        color #04cbd8
        font-size 30px
        font-weight bold

      .scmcc-register-logo-text
        font-size 16px
        font-weight 600
        color rgba(54, 107, 187, 1)
        line-height 1
        margin-left 8px

    .bottom-tip-text
      color #5e5f77
      font-size 14px

      span
        color #04cbd8
        cursor pointer

    .accept-text
      margin-top 14px

    .jump-text
      margin-top 158px
      text-align center

    .scmcc-register-form
      .scmcc-register-form-item
        margin-bottom 24px

        &.lastly
          margin-top 40px
          margin-bottom 0

        .ivu-select-selection
          height 52px

        .ivu-select-input, .ivu-input, .ivu-btn
          height 52px
          padding-left 20px
          color #515A6E
          font-size 16px

        .ivu-btn
          height 52px
          padding-left 20px
          font-size 20px
          color #ffffff
          border none

        .ivu-select-arrow
          right 12px
          color #BBC8D2

        .ivu-input-icon
          line-height 56px

        .ivu-input-suffix
          display flex
          align-items center

          .scmcc-register-form-item-icon
            width 20px

        .ivu-input-group-append
          color #ffffff
          font-size 16px
          background #04CBD8
          cursor pointer
          position relative
          padding 0
          width 120px
          height 52px
          line-height 52px
          overflow hidden

        .gray
          background #86E7F2

          .scmcc-register-form-item-checkcode
            position absolute
            top 0
            left 0
            height 100%
            width 100%

        .scmcc-register-form-item-domain
          padding 10px
          font-size 8px

      .ivu-form-item-label
        padding-bottom 7px
        padding-top 15px

      .scmcc-register-form-label
        display flex
        align-items center
        font-size 8px

        .scmcc-register-form-icon
          width 13px
          height 13px
          margin-right 4px
</style>
